import styled, { css } from "styled-components";
import breakpoint from "../../../../../utils/breakpoint";
import getBoxShadow from "../../../../../utils/getBoxShadow";
import getColor from "../../../../../utils/getColor";
import space from "../../../../../utils/space";
import transition from "../../../../../utils/transition";
import unit from "../../../../../utils/unit";
import { barHeightSpaceOnDesktop, barHeightSpaceOnMobile, breakpointValue, hugeBreakpointValue, zIndex } from "../settings";
import { containerBaseStyles } from "../styles";
export var Bar = styled.div.withConfig({
  componentId: "sc-1sim5tk-0"
})(function (_ref) {
  var $background = _ref.$background,
    theme = _ref.theme;
  return css(["", ";height:", ";&::before{z-index:", ";}> *{z-index:", ";}", "{justify-content:flex-end;}", "{height:", ";}"], containerBaseStyles(getColor(theme, $background)), space(barHeightSpaceOnMobile), zIndex.bar, zIndex.bar, breakpoint(breakpointValue), breakpoint(hugeBreakpointValue), space(barHeightSpaceOnDesktop));
});
export var AccountWrapper = styled.div.withConfig({
  componentId: "sc-1sim5tk-1"
})(["display:flex;position:relative;z-index:unset;align-self:stretch;", "{margin-left:", ";}"], breakpoint(breakpointValue), space(5));
export var AccountButtonWrapper = styled.div.withConfig({
  componentId: "sc-1sim5tk-2"
})(["z-index:", ";> *{height:100%;}"], zIndex.bar);
export var AccountDropdownWrapper = styled.div.withConfig({
  componentId: "sc-1sim5tk-3"
})(function (_ref2) {
  var $isActive = _ref2.$isActive,
    $additionalTopOffsetUnit = _ref2.$additionalTopOffsetUnit,
    theme = _ref2.theme;
  return css(["visibility:hidden;z-index:", ";right:0;", " ", "{", ";position:fixed;top:0;left:0;padding-top:", ";transform:translateY(-100%);", " ", "}", "{position:absolute;z-index:-1;top:", ";min-width:", ";opacity:0;", ";}"], zIndex.accountDropdown, $isActive && css(["visibility:visible;box-shadow:", ";"], getBoxShadow(theme, "large")), breakpoint("small", breakpointValue), transition("transform"), space(barHeightSpaceOnMobile), $isActive && css(["transform:translateY(0);"]), $additionalTopOffsetUnit ? css(["padding-top:calc( ", " + ", " );"], space(barHeightSpaceOnMobile), unit($additionalTopOffsetUnit)) : null, breakpoint(breakpointValue), space(barHeightSpaceOnDesktop), space(40), $isActive && css(["", ";z-index:", ";opacity:1;"], transition("opacity"), zIndex.accountDropdown));
});